export default "__VITE_ASSET__CGkU1TUo__"